import React from 'react';
export function UrgencyBar() {
  return <div className="bg-warm-brown text-cream py-3 px-4 text-center text-sm md:text-base font-medium sticky top-0 z-50 shadow-md pt-[8px] pb-[8px] pl-[9px] pr-[9px]" data-id="element-329">
      <p className="animate-pulse" data-id="element-330">
        🔥 OFERTA DE LANZAMIENTO — PRECIO ESPECIAL $19.999 — INCLUYE 4 BONOS
        GRATIS — SOLO POR TIEMPO LIMITADO 🔥
      </p>
    </div>;
}